import { render, staticRenderFns } from "./findId.vue?vue&type=template&id=10ac968b&scoped=true"
import script from "./findId.vue?vue&type=script&lang=js"
export * from "./findId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac968b",
  null
  
)

export default component.exports